var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _vm.records
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-sm" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.records, function (record, index, count) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _vm._v(
                        _vm._s(count != undefined ? count + 1 : index + 1)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.start))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.answer))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.from_number))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.to_number))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getDuration(record)))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.disconnect_reason))]),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.filteredMissed
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", [_vm._v("Пропушенные (отфильтрованные)")]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-2" }, [
              _c("label", { attrs: { for: `ch_i` } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showIgnored,
                      expression: "showIgnored",
                    },
                  ],
                  attrs: { type: "checkbox", name: "ignored", id: `ch_i` },
                  domProps: {
                    checked: Array.isArray(_vm.showIgnored)
                      ? _vm._i(_vm.showIgnored, null) > -1
                      : _vm.showIgnored,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.showIgnored,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.showIgnored = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showIgnored = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showIgnored = $$c
                        }
                      },
                      _vm.updateMissed,
                    ],
                  },
                }),
                _vm._v("\n            Показать скрытые\n          "),
              ]),
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table table-sm" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.filteredMissed, function (records, count) {
                  return _c(
                    "tr",
                    { attrs: { vif: "groupCalls(records)[0]" } },
                    [
                      _c("td", [_vm._v(_vm._s(count + 1))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(records[0].from_number))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.clients[_vm.getFirstRecord(records).from_number]
                            ? [
                                _vm.clients[
                                  _vm.getFirstRecord(records).from_number
                                ]
                                  ? _c("p", { staticClass: "mb-2" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.clients[
                                            _vm.getFirstRecord(records)
                                              .from_number
                                          ].name
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex flex-wrap orders_block",
                                  },
                                  _vm._l(
                                    _vm.getClientOrders(
                                      _vm.clients[
                                        _vm.getFirstRecord(records).from_number
                                      ].orders
                                    ),
                                    function (order) {
                                      return _c(
                                        "div",
                                        { staticClass: "orderInfo" },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(order.siteTitle) + " "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "(" + _vm._s(order.id) + ")"
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-muted" },
                                            [_vm._v(_vm._s(order.statusTitle))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-muted" },
                                            [_vm._v(_vm._s(order.report_date))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            : [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Клиент не найден в базе"),
                                ]),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(
                          _vm.groupCalls(records),
                          function (calls, number) {
                            return _c("div", { staticClass: "flex" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "vue-ladda",
                                    {
                                      attrs: {
                                        "button-class":
                                          "btn btn-sm btn-primary mr-5",
                                        "data-style": "zoom-in",
                                        loading: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.makeCallBack(calls[0])
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-phone-square",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _vm.phoneTitles[number]
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "phone_info" },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(_vm.phoneTitles[number])
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(number) +
                                                    " (" +
                                                    _vm._s(calls.length) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(number) +
                                            " (" +
                                            _vm._s(calls.length) +
                                            ")\n                  "
                                        ),
                                      ],
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "text-muted font-10" },
                                    [
                                      _vm._v(
                                        _vm._s(calls[calls.length - 1].start)
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm.getCallBacks(
                                  _vm.callBack[records[0].to_number],
                                  number
                                )
                                  ? _c(
                                      "div",
                                      { staticClass: "callBacks_info" },
                                      _vm._l(
                                        _vm.getCallBacks(
                                          _vm.callBack[records[0].to_number],
                                          number
                                        ),
                                        function (call, index) {
                                          return _c(
                                            "p",
                                            { staticClass: "font-10" },
                                            [_vm._v(_vm._s(call.start))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]),
                            ])
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm._l(
                            _vm.groupCalls(records),
                            function (calls, number) {
                              return [
                                _c(
                                  "form",
                                  {
                                    attrs: { action: "" },
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.saveComment($event, calls[0])
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "phones_comments_block",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.printComments(calls[0])
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(2, true),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "label",
                                        { attrs: { for: `ch_${calls[0].id}` } },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.ignored[
                                                    records[0].from_number
                                                  ][number],
                                                expression:
                                                  "ignored[records[0].from_number][number]",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              name: "ignored",
                                              id: `ch_${calls[0].id}`,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.ignored[
                                                  records[0].from_number
                                                ][number]
                                              )
                                                ? _vm._i(
                                                    _vm.ignored[
                                                      records[0].from_number
                                                    ][number],
                                                    null
                                                  ) > -1
                                                : _vm.ignored[
                                                    records[0].from_number
                                                  ][number],
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.ignored[
                                                      records[0].from_number
                                                    ][number],
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.ignored[
                                                          records[0].from_number
                                                        ],
                                                        number,
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.ignored[
                                                          records[0].from_number
                                                        ],
                                                        number,
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.ignored[
                                                      records[0].from_number
                                                    ],
                                                    number,
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(
                                            "\n                      Скрыть\n                    "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Время")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ответ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кто звонил")]),
        _vm._v(" "),
        _c("th", [_vm._v("Набранный номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Длительность")]),
        _vm._v(" "),
        _c("th", [_vm._v("CODE")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "50" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "140" } }, [_vm._v("Телефон")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "300" } }, [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "300" } }, [_vm._v("Звонки / Перезвоны")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group" }, [
      _c("input", {
        staticClass: "form-control",
        attrs: {
          type: "text",
          placeholder: "Комментарий",
          name: "commentText",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success",
            attrs: { name: "submitBtn", type: "submit" },
          },
          [_c("i", { staticClass: "icon-fa icon-fa-save" })]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }